<template>
  <b-modal :id="modalId" size="md" hide-footer>
    <template #modal-header>
      Select Profile Context
    </template>

    <template #default>
      <validation-observer ref="modalRuleProfileRef" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(onSubmit)">

          <p>Please select for which your profile, you want to add the created mock rule.</p>

          <validation-provider name="profile" rules="required" v-slot="validationContext">
            <b-form-group label="Profile" label-for="select-profile">
              <b-form-select
                id="select-profile"
                v-model="selectedProfile"
                value-field="token"
                text-field="name"
                :options="userProfiles"
                :state="getValidationState(validationContext)">
                <template #first>
                  <b-form-select-option :value="null" disabled>-- Please select profile --</b-form-select-option>
                </template>
              </b-form-select>
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <div class="d-flex justify-content-end mt-extra-large">
            <b-button variant="secondary" size="md" @click="closeModal">
              <i class="far fa-times-circle"></i> Cancel
            </b-button>
            <b-button type="submit" variant="primary">
              <span><i class="fas fa-save"></i> Save</span>
            </b-button>
          </div>

        </b-form>
      </validation-observer>
    </template>

  </b-modal>
</template>

<script>
  export default {
    props: {
      modalId: {
        type: String,
        default: 'modal-rule-select-profile'
      },
      onSuccess: {
        required: true,
        type: Function
      }
    },
    data() {
      return {
        userProfiles: [],
        selectedProfile: null
      };
    },
    methods: {
      getValidationState({dirty, validated, valid = null}) {
        return dirty || validated ? valid : null;
      },
      showModal(userProfiles) {
        this.userProfiles = userProfiles;
        this.selectedProfile = null;
        this.$bvModal.show(this.modalId)
      },
      closeModal() {
        this.$bvModal.hide(this.modalId)
      },
      onSubmit() {
        this.onSuccess(this.selectedProfile);
        this.closeModal();
      }
    }
  };
</script>
